/**
 * @generated SignedSource<<ca5d79a5973f8e57b0d5d46a53de185b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchLoomEntity_AtlassianSearchPage$data = {
  readonly __typename: string;
  readonly count?: number | null;
  readonly creatorName?: string | null;
  readonly id: string;
  readonly title: string;
  readonly totalNestedVideos?: number | null;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchLoomEntity_AtlassianSearchPage";
};
export type searchLoomEntity_AtlassianSearchPage$key = {
  readonly " $data"?: searchLoomEntity_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchLoomEntity_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchLoomEntity_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "totalNestedVideos"
        }
      ],
      "type": "SearchResultLoomFolder"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "creatorName"
        }
      ],
      "type": "SearchResultLoomPlaylist"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        }
      ],
      "type": "SearchResultLoomTag"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};

(node as any).hash = "d05e84012f1383964a66f526218d1b14";

export default node;
